import styled from "styled-components/macro";

export const Container = styled.section`
  margin-top: 56px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .inputSettingsHeading {
    margin: 0;
    font-size: 1.1rem;
    line-height: 1.3;
    font-weight: 600;
    margin-bottom: 5px !important;
  }

  .inputSettingRow {
    padding: 18px;
    border: 1px solid var(--grey-3);
    border-radius: 8px;
    background: var(--menu-color);
  }

  .inputSettingVariableHeading,
  .inputSettingField h3,
  .userTextCustomize h3 {
    margin: 0 0 6px;
    font-weight: 500;
  }

  .inputSettingVariableHeading{
    margin-bottom: 10px;
  }

  .inputSettingVariableChiclet {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    border-radius: 6px;
    padding: 2px 8px 2px 4px;
    border: 1px solid var(--grey-3);
    font-weight: 500;
    vertical-align: middle;
    cursor: default;
  }

  .inputSettingVariableChicletIcon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    background-color: var(--grey-0);
    mask: var(--input-setting-variable-icon) center / contain no-repeat;
    -webkit-mask: var(--input-setting-variable-icon) center / contain no-repeat;
  }

  .inputSettingVariableChicletLabel {
    font-size: 12px;
    color: var(--grey-0);
    line-height: 1.2;
    white-space: nowrap;
  }

  .inputSettingHeader p,
  .inputSettingField p,
  .userTextCustomize p {
    margin: 0;
    color: var(--grey-1);
    line-height: 130% !important;
  }

  .inputSettingFields {
    margin-top: 16px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .inputSettingField {
    min-width: 0;
  }

  .inputSettingField label,
  .userTextCustomize label {
    margin-bottom: 0 !important;
    width: 100%;
  }

  .inputSettingField input,
  .userTextInstructionInput {
    box-sizing: border-box;
    margin-top: 10px;
    width: 100%;
  }

  .userTextCustomize {
    margin-top: 16px;
  }

  .userTextPreview {
    margin-top: 14px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(220px, 1fr);
    gap: 20px;
    align-items: start;
    border: 3px solid var(--primary-cta-transparent);
    border-radius: 8px;
    padding: 18px;
  }

  .userTextPreview h3 {
    margin: 0 0 6px;
    font-weight: 500;
  }

  .userTextPreview p {
    margin: 0;
    color: var(--grey-1);
    line-height: 130% !important;
  }

  .error {
    margin-top: 8px;
  }

  @media (max-width: 900px) {
    .inputSettingFields,
    .userTextPreview {
      grid-template-columns: 1fr;
    }
  }
`;
